import { TemplateService } from '../../services/template.service';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import { ApiService } from '../../services/api.service';
import { SubSink } from 'subsink';
import { HttpParams } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { CALENDAR_LOCALE } from "../../services/constant";
// import {el} from "@angular/platform-browser/checkdateing/src/browser_util";
var EmailDashboardComponent = (function () {
    function EmailDashboardComponent(apiService, translate, template) {
        this.apiService = apiService;
        this.translate = translate;
        this.template = template;
        this.subs = new SubSink();
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.loading_main = false;
        this.datastatus = [];
        this.selectedCustomercode = null;
        this.deliverycodeList = null;
        this.selectedDeliverycode = null;
        this.allDeliverycodeList = [];
        this.startDate = null;
        this.endDate = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.sortBy = null;
        this.checkdate = null;
        this.sortMode = null;
        this.defaultLabel = null;
    }
    EmailDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadData();
        this.translate.onLangChange.subscribe(function (event) {
            // this.loadTexts();
            _this.getEmailReport();
        });
        this.getEmailReport();
        this.rdDocumentType = this.template.getDropdown();
        // this.loadTexts();
    };
    EmailDashboardComponent.prototype.getEmailReport = function () {
        var _this = this;
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        this.selectedCustomercode = null;
        this.customercode = null;
        this.selectedRdDocumentType = null;
        this.customercode = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.loading_main = true;
        this.data = this.apiService.getEmailReport().subscribe(function (res) {
            _this.emailTotal = res.transactions_sent + res.transactions_failed;
            _this.transactions_sent = res.transactions_sent;
            _this.transactions_failed = res.transactions_failed;
            _this.transactions_wait_for_send = res.transactions_wait_for_send;
            _this.transactions_not_sent = res.transactions_not_sent;
            _this.loading_main = false;
            _this.generateChart();
            _this.getTreeTableValue();
            _.forEach(res.results, function (obj) {
                _this.customercode.push({
                    label: obj.customer_code,
                    value: obj.customer_code
                });
                _this.allDeliverycodeList.push({
                    label: obj.delivery_code,
                    value: obj.customer_code
                });
            });
            _this.customercode = _.uniqBy(_this.customercode, 'label');
            _this.filterDeliverycodeList();
        });
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
    };
    EmailDashboardComponent.prototype.getTreeTableValue = function () {
        this.treeTableValue = {
            'data': [
                {
                    'data': {
                        'name': 'Documents',
                        'size': '75kb',
                        'type': 'Folder'
                    },
                    'children': [
                        {
                            'data': {
                                'name': 'Work',
                                'size': '55kb',
                                'type': 'Folder'
                            },
                            'children': [
                                {
                                    'data': {
                                        'name': 'Expenses.doc',
                                        'size': '30kb',
                                        'type': 'Document'
                                    }
                                },
                                {
                                    'data': {
                                        'name': 'Resume.doc',
                                        'size': '25kb',
                                        'type': 'Resume'
                                    }
                                }
                            ]
                        },
                        {
                            'data': {
                                'name': 'Home',
                                'size': '20kb',
                                'type': 'Folder'
                            },
                            'children': [
                                {
                                    'data': {
                                        'name': 'Invoices',
                                        'size': '20kb',
                                        'type': 'Text'
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    'data': {
                        'name': 'Pictures',
                        'size': '150kb',
                        'type': 'Folder'
                    },
                    'children': [
                        {
                            'data': {
                                'name': 'barcelona.jpg',
                                'size': '90kb',
                                'type': 'Picture'
                            }
                        },
                        {
                            'data': {
                                'name': 'primeui.png',
                                'size': '30kb',
                                'type': 'Picture'
                            }
                        },
                        {
                            'data': {
                                'name': 'optimus.jpg',
                                'size': '30kb',
                                'type': 'Picture'
                            }
                        }
                    ]
                }
            ]
        };
    };
    EmailDashboardComponent.prototype.generateChart = function () {
        var keepchart = this.transactions_sent + this.transactions_failed;
        this.sentChart = new Chart('sentChart', {
            type: 'doughnut',
            data: {
                // labels: ['Red', 'Blue', 'Yellow'],
                datasets: [{
                        label: 'Sent Chart',
                        data: [this.transactions_sent],
                        backgroundColor: [
                            '#16c8c8',
                            '#5b5a5a',
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                responsive: true,
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.errorChart = new Chart('errorChart', {
            type: 'doughnut',
            data: {
                // labels: ['Red', 'Blue', 'Yellow'],
                datasets: [{
                        label: '# of Votes',
                        data: [this.transactions_failed, keepchart],
                        backgroundColor: [
                            '#FF6384',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
    };
    EmailDashboardComponent.prototype.pageChanged = function () {
        this.loadData(this.currentPage);
    };
    EmailDashboardComponent.prototype.setPageSide = function () {
    };
    EmailDashboardComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    EmailDashboardComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.loadData();
    };
    EmailDashboardComponent.prototype.sentdate = function () {
        this.checkdate = 1;
    };
    EmailDashboardComponent.prototype.loadData = function (page, data) {
        var _this = this;
        this.datastatus = [];
        this.loading_main = true;
        this.customercode;
        var keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
        var keependDate = moment(this.endDate).format('YYYY-MM-DD');
        var params = new HttpParams();
        if (this.selectedCustomercode && this.selectedRdDocumentType) {
            params = params.append('customer_code', this.selectedCustomercode);
            params = params.append('document_type', this.selectedRdDocumentType);
        }
        if (data) {
            params = params.append('status', data);
        }
        if (this.selectedCustomercode) {
            params = params.append('customer_code', this.selectedCustomercode);
        }
        if (this.selectedRdDocumentType) {
            params = params.append('document_type', this.selectedRdDocumentType);
        }
        if (this.email) {
            params = params.append('email', this.email);
        }
        if (this.selectedDeliverycode) {
            params = params.append('customer_code', this.selectedDeliverycode);
        }
        // else if(keepstartDate)
        if (this.checkdate == 1) {
            params = params.append('document_date_gte', keepstartDate);
            params = params.append('document_date_lte', keependDate);
        }
        params = params.append('page', this.currentPage.toString());
        params = params.append('page_size', this.itemsPerPage.toString());
        this.apiService.getEmailDashboard(params).subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.totalItems = result.count;
                _this.datastatus.push({
                    email_data: obj.email_data.emails,
                    cc_email_data: obj.email_data.cc_list,
                    document_date: obj.document_date,
                    customer_code: obj.customer_code,
                    delivery_code: obj.delivery_code,
                    document_number: obj.document_number,
                    document_type: obj.document_type,
                    tax_data: obj.tax_data,
                    status: obj.status
                });
            });
            _this.loading_main = false;
        });
    };
    Object.defineProperty(EmailDashboardComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (2020) + ':' + (thisYear);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailDashboardComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    EmailDashboardComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    EmailDashboardComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    EmailDashboardComponent.prototype.clearData = function () {
        this.transactions_failed = null;
        this.transactions_wait_for_send = null;
        this.transactions_not_sent = null;
        this.transactions_sent = null;
        this.datastatus = null;
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.rdDocumentType = null;
        this.deliverycodeList = null;
        this.customercode = null;
        this.email = null;
        this.startDate = null;
        this.endDate = new Date();
        this.startDate = new Date();
        this.sortBy = null;
        this.sortMode = null;
        this.totalItems = null;
        this.checkdate = null;
        this.currentPage = 1;
        this.selectedDeliverycode = null;
        this.getEmailReport();
        this.loadData();
    };
    EmailDashboardComponent.prototype.filterDeliverycodeList = function () {
        var _this = this;
        this.selectedDeliverycode = null;
        this.deliverycodeList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allDeliverycodeList, function (obj) {
            if (_this.selectedCustomercode == null || obj.value == _this.selectedCustomercode)
                _this.deliverycodeList.push({
                    label: obj.label,
                    value: obj.value
                });
        });
    };
    EmailDashboardComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    return EmailDashboardComponent;
}());
export { EmailDashboardComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.ts.pre-build-optimizer.js